import httpStore from "@/api/httpStore.js";
import decamelizeKeysDeep from "decamelize-keys-deep";

export function getSupersessions() {
  return httpStore
    .get("supersessions")
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function getSupersessionsForPart(unificado) {
  return httpStore
    .get("supersessions/single/" + unificado)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function updateSupersession(supersessionId, newSupersession) {
  newSupersession = decamelizeKeysDeep(newSupersession);
  return httpStore
    .put(`supersessions`, {
      id: supersessionId,
      newSupersession: newSupersession
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
export function createSupersession(newSupersession, info, unificado) {
  newSupersession = decamelizeKeysDeep(newSupersession);
  return httpStore
    .post(`supersessions`, {
      alternative: newSupersession,
      unificado: unificado,
      info: info
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function requestDeleteSupersession(id) {
  return httpStore
    .delete(`supersessions?id=${id}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
